import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)
//
let actions = {
  importInvitations: {
    'method': 'POST',
    'url': '/api/v1/evaluate_invitations/import_invitations'
  },
  batchInvitations: {
    'method': 'PUT',
    'url': '/api/v1/evaluate_invitations/batch_invitations'
  },
  tag: {
    'method': 'PUT',
    'url': '/api/v1/evaluate_invitations{/_id}/update_tag'
  }
}

export default Vue.resource('/api/v1/evaluate_invitations{/_id}', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/invitation.js